// Import custom component
import Title from './title'
import Modal from './modals/modal'
import ModalConfirm from './modals/modal-confirm'
import ModalAddText from './modals/modal-add-text'
import ModalPortraitMode from './modals/modal-portrait-mode'
import SelectFont from './select/select-font'
import RangeInput from './rangeInput'
import ModalSaveAvatar from './modals/modal-save-avatar'
import Avatar from './avatar'
import Preview from './preview'
import ModalShapeInfo from './modals/modal-info-shape'
import Tab from './tabs'
import NavigateBar from './navigate'
import Checkbox from './checkbox'
import Chatbox from './chatbox'
import ChooseItem from './chooseItem'
import ChooseBg from './chooseBg/'
import HomeGuide from './home-guide'
import HomeGuideOtherStyle from './home-guide-other-style'
import PrintImage from './modals/modal-print-image'
import ModalColor from './modals/modal-color'
import PartTabWrapper from './part-tab-wrapper'
import PartTab from './part-tab'
import LoadFonts from './load-fonts'
import SelectCustom from './select/select-custom'
import ModalAvatarColor from './modals/modal-avatar-color'
import SideLeft from './layout/side-left'
import SideRight from './layout/side-right'
import Footer from './layout/footer'
import Header from './layout/header'

export default {
  's-title': Title,
  's-modal': Modal,
  's-modal-confirm': ModalConfirm,
  's-modal-add-text': ModalAddText,
  's-select-font': SelectFont,
  's-range-input': RangeInput,
  's-modal-save-avatar': ModalSaveAvatar,
  's-layout-avatar': Avatar,
  's-preview': Preview,
  's-tab': Tab,
  's-modal-shapeinfo': ModalShapeInfo,
  's-navigate-bar': NavigateBar,
  's-checkbox': Checkbox,
  's-chatbox': Chatbox,
  's-choose-item': ChooseItem,
  's-choose-item-bg': ChooseBg,
  's-home-guide': HomeGuide,
  's-modal-portrait-mode': ModalPortraitMode,
  's-modal-print-image': PrintImage,
  's-modal-color': ModalColor,
  's-part-tab-wrapper': PartTabWrapper,
  's-part-tab': PartTab,
  's-load-fonts': LoadFonts,
  's-select-custom': SelectCustom,
  's-modal-avatar-color': ModalAvatarColor,
  's-home-guide-other-style': HomeGuideOtherStyle,
  's-side-left': SideLeft,
  's-side-right': SideRight,
  's-footer': Footer,
  's-header': Header,
}
